var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:`${
    !_vm.$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
  }`,attrs:{"id":"planbordtweb"}},[_c('router-view'),_c('global-loader'),_c('snack-bars')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }